import { render, staticRenderFns } from "./SourceStatisticsModule.vue?vue&type=template&id=28554136&scoped=true"
import script from "./SourceStatisticsModule.vue?vue&type=script&lang=js"
export * from "./SourceStatisticsModule.vue?vue&type=script&lang=js"
import style0 from "./SourceStatisticsModule.vue?vue&type=style&index=0&id=28554136&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28554136",
  null
  
)

export default component.exports